(() => {
  const collection = document.body.classList.contains('tt12-template-collection');
  const product = document.body.classList.contains('tt12-template-product');
  const interior = document.body.classList.contains('toasty-interior-navigation-page');
  if (!collection && !product && !interior) return;
  const mobile = matchMedia('(max-width: 989px)');
  const root = document.documentElement;
  const seedHistory = () => {
    if (!collection) return;
    if (!history.state || !('searchParams' in history.state)) {
      history.replaceState({ ...history.state, searchParams: location.search.slice(1) }, '', location.href);
    }
  };
  seedHistory();
  window.addEventListener('pageshow', seedHistory);
  let dock;
  let purchase;
  const categories = document.querySelector('.tt13-commerce-category-nav');
  const moveCategories = () => {
    if (!categories) return;
    const slot = document.querySelector('#left-drawer-slot [data-toasty-collection-categories]');
    if (slot && categories.parentElement !== slot) slot.append(categories);
  };
  const measure = () => {
    const height = dock ? Math.ceil(dock.getBoundingClientRect().height + parseFloat(getComputedStyle(dock).bottom) + 16) : 0;
    root.style.setProperty('--toasty-collection-dock-height', `${height}px`);
    document.body.style.setProperty('--toasty-collection-dock-height', `${height}px`);
    const purchaseHeight = purchase?.dataset.purchaseShown === 'true' ? Math.ceil(purchase.getBoundingClientRect().height) : 0;
    root.style.setProperty('--toasty-sticky-purchase-height', `${purchaseHeight}px`);
    document.body.style.setProperty('--toasty-sticky-purchase-height', `${purchaseHeight}px`);
  };
  const resize = new ResizeObserver(measure);
  const connect = () => {
    moveCategories();
    const nextPurchase = document.querySelector('[data-toasty-sticky-purchase]');
    if (nextPurchase !== purchase) {
      if (purchase) resize.unobserve(purchase);
      purchase = nextPurchase;
      if (purchase) resize.observe(purchase);
    }
    const next = document.querySelector('[data-toasty-collection-dock]');
    const label = document.querySelector('[data-collection-filter-label]')?.textContent.trim().replace(/\s+/g, ' ');
    const trigger = next?.querySelector('.toasty-collection-filter');
    if (label && trigger && trigger.textContent.trim() !== label) trigger.textContent = label;
    if (next === dock) { measure(); return; }
    if (dock) resize.unobserve(dock);
    dock = next;
    if (dock) resize.observe(dock);
    measure();
  };
  new MutationObserver(connect).observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['data-purchase-shown'] });
  mobile.addEventListener('change', () => { seedHistory(); connect(); });
  window.addEventListener('resize', measure);
  connect();
})();
